import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../context/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const AdminRoute = ({ children }) => {
    const { isAuthenticated, loading, user } = useContext(AuthContext);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Redirect to dashboard if user is not authenticated or not an admin
    if (!isAuthenticated || (user && user.role !== 'admin')) {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default AdminRoute; 